import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from 'ck-ui';
import { FooterSignUpForm } from './FooterSignUpForm';
import styles from './FooterSignUp.module.scss';

const FooterSignUp = ({ footerHeading, footerContent }) => {
  const [hasSignedUp, setHasSignedUp] = useState(false);

  const onSignUpSuccess = () => {
    setHasSignedUp(true);
  };

  return (
    <div className={classnames(styles.root)}>
      <div className={styles.newsLetterFooter}>
        <div className="container">
          <div
            role="presentation"
            className={styles.cbTextContainer}
          >
            <div className={classnames(styles.cbText, styles.cbTextOpen)}>
              {footerHeading}
            </div>
          </div>
          {hasSignedUp ? (
            <div className={styles.confirmation}>
              <Icon name="ck-logo" size="exLarge" className={styles.logoIcon} />
              <div className={styles.confirmHeader}>YOU'RE IN!</div>
              <div className={styles.confirmText}>You'll hear from us as soon as we've got any new drops, exclusive offers or promotions.</div>
            </div>
          ) : (
            <FooterSignUpForm
              nlText={footerContent}
              onSignUpSuccess={onSignUpSuccess}
            />
          )}
        </div>
      </div>
    </div>
  );
};

FooterSignUp.propTypes = {
  footerHeading: PropTypes.string.isRequired,
  footerContent: PropTypes.string.isRequired,
};

export { FooterSignUp };
